module.exports = __webpack_public_path__ + "static/img/kaenyoushi.ea29a27d.png";